import { defineStore } from 'pinia'
import { getShop, getDeliveryDates } from '@/api/api'
import { useShopsStore } from '@/stores/Shops.store'

export const usePrintProductSecuredSAStore = defineStore(
  'printProductSecuredSA',
  {
    state: () => ({
      orderDetails: {
        instruction: '',
        deliveryAddress: {},
        invoiceAddress: {},
        letter: '',
        deliveryDate: {},
        orderType: 'deliver',
        secure: true,
        quotationNo: '',
        project: {
          id: 0,
          name: ''
        },
        reference: '',
        externalId: ''
      },
      shop: {},
      dates: [],
      orderErrors: [],
      printTemplatesSecure: undefined
    }),
    actions: {
      addOrderError(error) {
        if (!this.orderErrors.includes(error)) {
          this.orderErrors.push(error)
        }
      },
      removeOrderError(error) {
        this.orderErrors = this.orderErrors.filter((e) => e !== error)
      },
      updateOrderDetails(key, value) {
        this.orderDetails[key] = value
      },
      updateProject(proj) {
        this.orderDetails.project.name = proj.name || ''
        this.orderDetails.project.id = proj.id || 0
      },
      resetOrderDetails() {
        this.orderDetails = {
          instruction: '',
          deliveryAddress: {},
          invoiceAddress: {},
          letter: '',
          deliveryDate: {},
          orderType: 'deliver',
          secure: true,
          quotationNo: '',

          project: {
            id: 0,
            name: ''
          },
          reference: '',
          externalId: ''
        }
        this.shop = {}
        this.dates = []
        this.orderErrors = []
      },
      updateShop(shop) {
        this.shop = shop
      },
      updateDates(dates) {
        this.dates = dates
      },
      getTheDates(val) {
        return getDeliveryDates(val.shopId, val.invoiceId, val.secure).then(
          (resp) => {
            this.updateDates(resp)
            return resp
          }
        )
      },
      getTheShop(val) {
        const shopsStore = useShopsStore()
        getShop(val.deliveryAddress, val.invoiceId, val.secure).then((resp) => {
          const shop =
            shopsStore.shopsList.find((shop) => shop.id === resp.location.id) ||
            {}
          this.updateShop(shop)
        })
      }
    }
  }
)
